<div *ngIf="czyPosiadaAtrybuty">
    <div [formGroup]="formularzUszkodzenia" class="{{formularzWidoczny ? 'd-block' : 'd-none'}} checkbox-depended ml-0">
        <div class="o-flex o-flex--grids c-card c-card-sm mb-3 ml-0 mr-0 copyItem">
            <div *ngIf="pokazWyczyscElement" class="col-lg-12">
                <i class="c-icon c-icon--9_16 u-icon--natural c-pointer float-right" title="Usuń" style="outline: 0;" (click)="wyczyscElement()"></i>
            </div>
            <div class="o-flex o-flex--grids mb-3 ml-0 mr-o copyItem filled">
                <div *ngIf="rodzajePowierzchni" class="o-flex__item u-flex-1/2@tablet u-flex-1/1@small">
                    <shared-rodzaj-powierzchni
                            [formularz]="formularzUszkodzenia"
                            [rodzajePowierzchni]="rodzajePowierzchni">
                    </shared-rodzaj-powierzchni>
                </div>
                <div *ngIf="pokazSzerokosc" class="o-flex__item u-flex-1/2@tablet u-flex-1/1@small">
                    <shared-szerokosc
                            [formularzUszkodzenia]="formularzUszkodzenia"
                            [minimalnaSzerokosc]="minimalnaSzerokosc"
                            [maksymalnaSzerokosc]="maksymalnaSzerokosc"
                    >
                    </shared-szerokosc>
                </div>
                <div *ngIf="pokazWysokosc" class="o-flex__item u-flex-1/2@tablet u-flex-1/1@small">
                    <shared-wysokosc
                            [formularzUszkodzenia]="formularzUszkodzenia"
                            [minimalnaWysokosc]="minimalnaWysokosc"
                            [maksymalnaWysokosc]="maksymalnaWysokosc"
                    >
                    </shared-wysokosc>
                </div>
                <div *ngIf="rodzajeMaterialowWykonczenia" class="o-flex__item u-flex-1/2@tablet u-flex-1/1@small">
                    <shared-material-wykonczenia
                            [formularz]="formularzUszkodzenia"
                            [rodzajeMaterialowWykonczenia]="rodzajeMaterialowWykonczenia">
                    </shared-material-wykonczenia>
                </div>
                <div *ngIf="pokazWartosc" class="o-flex__item u-flex-1/2@tablet u-flex-1/1@small">
                    <shared-wartosc
                            [formularzUszkodzenia]="formularzUszkodzenia"
                            [jednostkaPowierzchniUszkodzenia]="jednostkaPowierzchniUszkodzenia"
                            [czyWalidacjaWgPowierzchni]=czyWalidacjaWgPowierzchni
                            [minimalnaWartoscUszkodzenia]="minimalnaWartoscUszkodzenia"
                            [maksymalnaWartoscUszkodzenia]="maksymalnaWartoscUszkodzenia"
                            [etykietaWartosci]=etykietaWartosci>
                    </shared-wartosc>
                </div>
              <div *ngIf="pokazKomentarz" class="o-flex__item">
                <shared-komentarz
                  [formularzUszkodzenia]="formularzUszkodzenia"
                  [etykietaWartosci]=etykietaWartosci>
                </shared-komentarz>
              </div>
              <div *ngIf="pokazFolieReklamowa" class="o-flex__item w-85 mt-2">
                <shared-folia-reklamowa
                  [formularzUszkodzenia]="formularzUszkodzenia">
                </shared-folia-reklamowa>
              </div>
            </div>
        </div>
    </div>
</div>
